(function () {
  'use strict';

  const settings = window.FTY_CART_SETTINGS || {};

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    const safePrecision = precision == null ? 2 : precision;
    const safeThousands = thousands == null ? ',' : thousands;
    const safeDecimal = decimal == null ? '.' : decimal;
    if (Number.isNaN(Number(number))) return '0';

    const parts = (Number(number) / 100).toFixed(safePrecision).split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${safeThousands}`);
    return dollars + (parts[1] ? `${safeDecimal}${parts[1]}` : '');
  }

  function formatMoney(cents, requestedFormat) {
    const format = requestedFormat || (settings.showCurrency ? settings.moneyFormatWithCurrency : settings.moneyFormat);
    if (!format) return `$${formatWithDelimiters(cents, 2)}`;
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return `$${formatWithDelimiters(cents, 2)}`;

    let value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(match[0], value);
  }

  function emit(cart) {
    document.querySelectorAll('.cart-count').forEach((element) => {
      element.textContent = cart.item_count;
    });
    document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
    return cart;
  }

  async function request(url, options) {
    const response = await fetch(url, options);
    const payload = await response.json();
    if (!response.ok || payload.status === 422) {
      throw new Error(payload.description || payload.message || 'Cart could not be updated.');
    }
    return payload;
  }

  function fetchCart() {
    return request('/cart.js');
  }

  async function add(variantId, quantity) {
    await request('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }] })
    });
    return emit(await fetchCart());
  }

  async function change(lineKey, quantity) {
    const cart = await request('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: Math.max(0, Number(quantity) || 0) })
    });
    return emit(cart);
  }

  function itemForVariant(cart, variantId) {
    return cart.items.find((item) => String(item.variant_id) === String(variantId)) || null;
  }

  window.FTYCart = {
    add,
    change,
    emit,
    escapeHtml,
    fetchCart,
    formatMoney,
    itemForVariant
  };
})();
